import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent, bootloader } from '@frontend/vanilla/core';

import { getAppConfig } from './app.config';

bootloader().then(() => {
    // eslint-disable-next-line promise/no-nesting
    bootstrapApplication(AppComponent, getAppConfig()).catch((error: unknown) => console.error(error));
});
